module.exports = __webpack_public_path__ + "static/img/zhong6.5c68db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong6.png
// module id = 9BQg
// module chunks = 16